import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export function LeadForm({ source, fields = ["name", "phone", "email", "message"], title, cta = "Submit", extra }) {
  const [form, setForm] = useState({});
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error("Name and mobile are required"); return; }
    setLoading(true);
    try {
      await api.post("/leads", { ...form, source });
      setDone(true);
      toast.success("Thank you! We'll be in touch shortly.");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (done) return (
    <div className="text-center py-10" data-testid="lead-success">
      <CheckCircle2 className="mx-auto text-green-600 mb-3" size={44} />
      <h3 className="font-serif text-2xl text-navy">Request Received!</h3>
      <p className="text-muted-foreground mt-1">Our team will reach out to you soon.</p>
    </div>
  );

  const LABELS = { name: "Full Name", phone: "Mobile Number", email: "Email", location: "Location", event_type: "Event Type", event_date: "Event Date", guests: "Number of Guests", budget: "Budget", requirement: "Requirement", message: "Message" };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`lead-form-${source.toLowerCase().replace(/\s/g, "-")}`}>
      {title && <h3 className="font-serif text-2xl text-navy mb-1">{title}</h3>}
      <div className="grid sm:grid-cols-2 gap-3">
        {fields.filter((f) => f !== "message" && f !== "requirement").map((f) => (
          <div key={f} className={f === "name" ? "sm:col-span-2" : ""}>
            <label className="text-xs font-medium text-muted-foreground">{LABELS[f]}</label>
            <input type={f === "event_date" ? "date" : "text"} value={form[f] || ""} onChange={set(f)} data-testid={`lead-${f}`} className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" />
          </div>
        ))}
      </div>
      {(fields.includes("requirement")) && <div><label className="text-xs font-medium text-muted-foreground">{LABELS.requirement}</label><textarea value={form.requirement || ""} onChange={set("requirement")} rows={2} data-testid="lead-requirement" className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" /></div>}
      {fields.includes("message") && <div><label className="text-xs font-medium text-muted-foreground">{LABELS.message}</label><textarea value={form.message || ""} onChange={set("message")} rows={3} data-testid="lead-message" className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" /></div>}
      {extra}
      <button type="submit" disabled={loading} data-testid="lead-submit" className="btn-shine bg-navy text-cream font-semibold px-7 py-3 rounded-full hover:bg-navy-soft transition-colors disabled:opacity-60">{loading ? "Submitting..." : cta}</button>
    </form>
  );
}
